import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import customerController from '../../redux/api/tbCustomerController';
import telemetryController from '../../redux/api/tbTelemetryController';
import deviceController from '../../redux/api/tbDeviceController';

export const initialState = {
  customers: [],
  status: 'idle',
};

export const getDataCustomers = createAsyncThunk(
  'dataCustomers',
  async (data) => {
    const { token } = data;
    let response = await customerController.getCustomerById(token);
    const result = await Promise.all(
      response.data.map(async (item) => {
        let attribute = await telemetryController.getAttributesByScope(
          token,
          item.id.entityType,
          item.id.id,
          'avatar'
        );
        const pageSize = 1000;
        const page = 0;
        let device = await deviceController.getCustomerDevices(
          token,
          item.id.id,
          pageSize,
          page
        );
        return {
          ...item,
          avatar: attribute[0],
          device: device.data,
        };
      })
    );
    response.data = result;
    return response;
  }
);

export const saveCustomersInfo = createAsyncThunk(
  'saveCustomer',
  async (data) => {
    const { token, customerId, tenantId, name, phone, email, address, file } =
      data;
    let customer = {
      title: name,
      address: address,
      phone: phone,
      email: email,
    };
    if (customerId) {
      customer = {
        ...customer,
        id: {
          id: customerId,
          entityType: 'CUSTOMER',
        },
        tenantId: {
          id: tenantId,
          entityType: 'TENANT',
        },
      };
    }
    const response = await customerController.saveCustomer(token, customer);
    const responseAvatar = await telemetryController.saveEntityAttributesV1(
      token,
      'CUSTOMER',
      response.id.id,
      {
        avatar: file,
      }
    );
    return responseAvatar;
  }
);

export const deleteCustomer = createAsyncThunk(
  'deleteCustomer',
  async (data) => {
    const { token, customerId } = data;
    const response = await customerController.deleteCustomer(token, customerId);
    return response;
  }
);

export const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDataCustomers.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(getDataCustomers.fulfilled, (state, action) => {
      state.status = 'idle';
      state.customers = action.payload;
    });
    builder.addCase(getDataCustomers.rejected, (state) => {
      state.status = 'failed';
      state.customers = [];
    });
    // saveCustomersInfo
    builder.addCase(saveCustomersInfo.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(saveCustomersInfo.fulfilled, (state, action) => {
      state.status = 'success';
      toast.success('Successfully saved customer information.');
    });
    builder.addCase(saveCustomersInfo.rejected, (state) => {
      state.status = 'failed';
      toast.error('The name cannot be the same as the existing name.');
    });
    // deleteCustomer
    builder.addCase(deleteCustomer.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(deleteCustomer.fulfilled, (state, action) => {
      state.status = 'success';
      toast.success('Deleted customer information successfully.');
    });
    builder.addCase(deleteCustomer.rejected, (state) => {
      state.status = 'failed';
      toast.error('Delete customer information failed.');
    });
  },
});

export default customersSlice.reducer;

export const allCustomerInfos = (state) => state.customers.customers;
